import React from "react";
import { motion } from "framer-motion";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";
import "./Roadmap.css";

const progressData = [
    {
      title: "Phase 1",
      progress: 100,
      items: [
        "Genesis block generation: Create the first block of the MenelikCoin blockchain.",
        "Mainnet testing: Conduct extensive testing on the main network to ensure its stability and security.",
        "Explorer launch: Deploy a block explorer to visualize transactions and blocks on the blockchain.",
        "Wallet launch for Windows: Release the official MenelikCoin wallet for Windows.",
      ],
    },
    {
      title: "Phase 2",
      progress: 100,
      items: [
        "Official website launch: Create and launch the official MenelikCoin website.",
        "Pre-release of documentation: Publish a preliminary version of the technical and user documentation.",
        "Initial whitepaper release: Publish the initial whitepaper outlining vision, technology, and applications.",
        "Creation of social networks: x.com, Telegram, Discord.",
      ],
    },
    {
      title: "Phase 3",
      progress: 70,
      items: [
        "Development of the interactive web is abandoned.",
        "The initial idea of ​​building documentation and websites in Spanish was abandoned.",
        "Telegram Bot: Development and launch of a bot to interact with the community.",
        "Discord Bot: Development and launch of a bot on Discord.",
        "Initial promotions: Marketing and promotional strategies to increase visibility.",
        "Project progress evaluation: Thorough review of progress and achievements.",
      ],
    },
    {
      title: "Phase 4",
      progress: 40,
      items: [
        "The Roadmap website will be redesigned.",
        "Creating a new main website.",
        "Rebuilding of English language documentation and websites begins.",
        "Explorer relaunch: Essential data for Holders is integrated, including details of Locked Coins, Burnt Coins, Supply, etc.",
        "Web wallet service development: Create an accessible web-based wallet.",
        "Android wallet implementation: Develop and launch the official MenelikCoin wallet for Android.",
        "Referral and rewards system: Implementation to encourage community expansion.",
        "Exchange listings: Work towards listing MenelikCoin on various exchanges.",
        "Gaming node evolution: Develop and improve nodes for gaming applications.",
      ],
    },
    {
      title: "Phase 5",
      progress: 56,
      items: [
        "Airdrop launch: Distribution of MenelikCoin to incentivize initial adoption.",
        "Menelik Game development: Create games that use MenelikCoin as a transaction medium.",
        "Menelik Game launch: Official release of games to the public.",
        "Publication of Menelik game rules: Ecosystem and rule details, burning system, funds, and referrals, etc.",
        "Marketing: Continue and expand strategies to increase adoption.",
        "Project planning and reevaluation: Adjust the plan for future stages.",
      ],
    },
    {
      title: "Phase 6",
      progress: 2,
      items: [
        "COMPLEMENT PHASE 5: Create games that use MenelikCoin as a transaction medium.",
        "COMPLEMENT PHASE 5: Official release of games to the public.",
        "Marketing: Continue and expand strategies to increase adoption.",
        "Project planning and reevaluation: Adjust the plan for future stages.",
      ],
    },
    {
      title: "Phase 7",
      progress: 15,
      items: [
        "Menelik Cross-Chain",
        "Planning and Design",
        "Define technical requirements and validation rules",
        "Design the contract structure and integration with Menelik",
        "Specify the fee system and MENEL burning mechanism",
        "Smart Contract and Backend Development",
        "Implementation of the Liquidity Contribution System",
        "User Interface Development",
        "Testing on Testnet and Security Audit",
        "Mainnet Launch and Monitoring",
        "Expansion and Improvements"
      ],
    },
    
  ];
  
export const Roadmap = () => {
  const phases = progressData.map((phase) => ({
    ...phase,
    completed: phase.progress === 100,
  }));

  const phaseData = phases.map((phase) => ({
    name: phase.title,
    progress: phase.progress,
  }));

  const totalProgress =
    phases.reduce((acc, phase) => acc + phase.progress, 0) / phases.length;

  const pieData = [
    { name: "Filled", value: totalProgress },
    { name: "Earring", value: 100 - totalProgress },
  ];

  const COLORS = ["#4CAF50", "#FFC107"];

  return (
    <div className="roadmap-container">
      <h1>MenelikCoin Roadmap</h1>
      <div className="charts-container">
        <div className="roadmap-progress-chart">
          <ResponsiveContainer width={250} height={250}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={120}
                fill="#4CAF50"
                paddingAngle={5}
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="roadmap-chart">
          <h2>Progress by Phase</h2>
          <ResponsiveContainer width={300} height={200}>
            <BarChart data={phaseData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis domain={[0, 100]} />
              <Tooltip />
              <Bar dataKey="progress" fill="#4CAF50" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {phases.map((phase, index) => (
        <motion.div
          key={index}
          className={`roadmap-phase ${phase.completed ? "completed" : ""}`}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2>{phase.title}</h2>

          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{
                width: `${phase.progress}%`,
                backgroundColor: phase.completed ? "#4CAF50" : "#FFC107",
              }}
            ></div>
          </div>

          <ul>
            {phase.items.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </motion.div>
      ))}
    </div>
  );
};
